module.exports = __webpack_public_path__ + "img/promo.80c2b0a0.png";